/**
 * Objects with unknown keys and values.
 */
 interface IMetadataObj {
    [key: string]: any;
}

/**
 * Convert number to string and add a comma for thousands and millions.
 */
const formatNumberComma = (value: number) => new Intl.NumberFormat("en-US").format(value);

/**
 * Formats a date in the numeric US format (6/21/2003).
 */
const formatCardDate = (date: Date) => {
    const intlDateString = new Intl.DateTimeFormat("en-us", {
        month: "short",
        year: "2-digit",
    });
    return intlDateString.format(date).toString();
};

/**
 * Returns true if the param is truthy or the string true.
 */
const isTruthy = (string: string) => /^(true|1)$/.test(string.toLowerCase());

/**
 * Returns combined string of all existing values.
 */
const joinExisting = (strings: string[], joiner: string = " ") => strings.filter(Boolean).join(joiner);

export {
    formatCardDate,
    formatNumberComma,
    isTruthy,
    joinExisting,
};

export type { IMetadataObj };
